const simplePath = [
    {
        label: "IF",
        role: "IF",
        input: null,
        output: "IF/ID",
        latency: 1,
        canDelay: true
    },
    {
        label: "ID",
        role: "ID",
        input: "IF/ID",
        output: "ID/EX",
        latency: 1,
        canDelay: true
    },
    {
        label: "EX",
        role: "EX",
        input: "ID/EX",
        output: "*/WB",
        latency: 1,
        canDelay: true
    },
    {
        label: "WB",
        role: "WB",
        input: "*/WB",
        output: null,
        latency: 1,
        canDelay: false
    }
];

const floatingPoint2 = {
    name: "Lebegőpontos 2.",
    paths: {
        "int*": {
            phases: simplePath,
            opARequired: "EX",
            opBRequired: "EX",
            targetProvided: "EX",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "jump*": {
            phases: simplePath,
            opARequired: "",
            opBRequired: "EX",
            targetProvided: "",
            registerWriteBack: "",
            registerReadOut: "ID"
        },
        "mem*": {
            phases: [
                {
                    label: "IF",
                    role: "IF",
                    input: null,
                    output: "IF/ID",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "ID",
                    role: "ID",
                    input: "IF/ID",
                    output: "ID/AG",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "AG",
                    role: "EX",
                    input: "ID/AG",
                    output: "AG/MEM",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "MEM",
                    role: "MEM",
                    input: "AG/MEM",
                    output: "*/WB",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "WB",
                    role: "WB",
                    input: "*/WB",
                    output: null,
                    latency: 1,
                    canDelay: false
                }
            ],
            opARequired: "AG",
            opBRequired: "MEM",
            targetProvided: "MEM",
            registerWriteBack: "WB",
            registerReadOut: "ID"
        },
        "float*": {
            phases: [
                {
                    label: "IF",
                    role: "IF",
                    input: null,
                    output: "IF/ID",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "ID",
                    role: "ID",
                    input: "IF/ID",
                    output: "ID/A0",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "A0",
                    role: "EX",
                    input: "ID/A0",
                    output: "A0/A1",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "A1",
                    role: "EX",
                    input: "A0/A1",
                    output: "A1/A2",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "A2",
                    role: "EX",
                    input: "A1/A2",
                    output: "*/WB",
                    latency: 1,
                    canDelay: true
                },                                
                {
                    label: "WB",
                    role: "WB",
                    input: "*/WB",
                    output: null,
                    latency: 1,
                    canDelay: false
                }
            ],
            opARequired: "A0",
            opBRequired: "A0",
            targetProvided: "A2",
            registerWriteBack: "WB",
            registerReadOut: "ID"         
        },
        "float.*": {
            phases: [
                {
                    label: "IF",
                    role: "IF",
                    input: null,
                    output: "IF/ID",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "ID",
                    role: "ID",
                    input: "IF/ID",
                    output: "ID/M0",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "M0",
                    role: "EX",
                    input: "ID/M0",
                    output: "M0/M1",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "M1",
                    role: "EX",
                    input: "M0/M1",
                    output: "M1/M2",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "M2",
                    role: "EX",
                    input: "M1/M2",
                    output: "M2/M3",
                    latency: 1,
                    canDelay: true
                },         
                {
                    label: "M3",
                    role: "EX",
                    input: "M2/M3",
                    output: "M3/M4",
                    latency: 1,
                    canDelay: true
                },                     {
                    label: "M4",
                    role: "EX",
                    input: "M3/M4",
                    output: "*/WB",
                    latency: 1,
                    canDelay: true
                },                                            
                {
                    label: "WB",
                    role: "WB",
                    input: "*/WB",
                    output: null,
                    latency: 1,
                    canDelay: false
                }
            ],
            opARequired: "M0",
            opBRequired: "M0",
            targetProvided: "M4",
            registerWriteBack: "WB",
            registerReadOut: "ID"         
        },
        "float./": {
            phases: [
                {
                    label: "IF",
                    role: "IF",
                    input: null,
                    output: "IF/ID",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "ID",
                    role: "ID",
                    input: "IF/ID",
                    output: "ID/DIV",
                    latency: 1,
                    canDelay: true
                },
                {
                    label: "DIV",
                    role: "EX",
                    input: "ID/DIV",
                    output: "*/WB",
                    latency: 6,
                    canDelay: true
                },
                {
                    label: "WB",
                    role: "WB",
                    input: "*/WB",
                    output: null,
                    latency: 1,
                    canDelay: false
                }
            ],
            opARequired: "DIV",
            opBRequired: "DIV",
            targetProvided: "DIV",
            registerWriteBack: "WB",
            registerReadOut: "ID"         
        }        
    },
    description: "A pipeline minden utasítás végrehajtását 4 részműveletre bontja: betölti (IF), dekódolja (ID),"
    +" végrehajtja a vonatkozó műveleteket, végül a regisztertárolóba"
    +" írja az eredményregiszter értékét (WB). Az IF, ID, és WB fázisok késleltetése 1 órajel. Az aritmetikai művelet lehet"
    +" egész művelet, mely késleltetése 1 órajel (EX, a címszámítást nem ez az egység végzi), lebegőpontos összeadás, melynek"
    +" késleltetése 3, iterációs ideje 1 (A0, A1, A2), lebegőpontos szorzás, melynek késleltetése 5, iterációs ideje 1"
    +" (M0, M1, M2, M3, M4), valamint lebegőpontos osztás, melynek mind a késleltetése, mint az iterációs ideje 6."
    +" A memóriaműveletek egy címszámításból (AG) és magából a memória hozzáfordulásból (MEM) állnak."
    +" Az aritmetikai és memória egységek képesek párhuzamos működésre, és az utasítások soron kívüli"
    +" befejezésére, ha ennek semmilyen szemantikai vagy egymásrahatásbeli akadálya nincs. Minden forwarding út használata"
    +" megengedett. Ha bármilyen egymásrahatás az utasítás megállítását igényli, az utasítás mindig a legutolsó"
    +" olyan fázisban áll meg, ameddig egymásrahatás nélkül eljut."
};

export default floatingPoint2;